<div class="tabs__grid-item">
  <interconnect-summary
    [service]="service()"
    [subscriptionInstanceId]="subscriptionInstanceId()"
    [forceTrafficBottom]="true"
    style="width: 100%"
  />
</div>

<div class="tabs__grid-item">
  <div class="tabs__flex-center">
    <h3>{{ "ServiceElement.IPConfiguration" | translate }}</h3>
  </div>
  <div class="tabs__table">
    <div class="tabs__table-row">
      <div class="tabs__table-col">{{ "ServiceElement.AvailabilityZone" | translate }}</div>
      <div class="tabs__table-col">{{ availabilityZone() }}</div>
    </div>
    <div class="tabs__table-row">
      <div class="tabs__table-col">{{ "ServiceElement.FirewallASN" | translate }}</div>
      <div class="tabs__table-col">{{ firewallAsn() }}</div>
    </div>
    @if (ipv4Prefix() !== null) {
      <div class="tabs__table-row">
        <div class="tabs__table-col">{{ "ServiceElement.IPv4Prefix" | translate }}</div>
        <div class="tabs__table-col">{{ ipv4Prefix() }}</div>
      </div>
    }
    @if (ipv4AddressFirewall() !== null) {
      <div class="tabs__table-row">
        <div class="tabs__table-col">{{ "ServiceElement.IPv4AddressFirewall" | translate }}</div>
        <div class="tabs__table-col">{{ ipv4AddressFirewall() }}</div>
      </div>
    }
    @if (ipv4Mtu() !== null) {
      <div class="tabs__table-row">
        <div class="tabs__table-col">{{ "ServiceElement.IPv4MTU" | translate }}</div>
        <div class="tabs__table-col">{{ ipv4Mtu() }}</div>
      </div>
    }
    @if (ipv4MaxPrefix() !== null) {
      <div class="tabs__table-row">
        <div class="tabs__table-col">{{ "ServiceElement.IPv4MaxPrefix" | translate }}</div>
        <div class="tabs__table-col">{{ ipv4MaxPrefix() }}</div>
      </div>
    }
    @if (ipv6Prefix() !== null) {
      <div class="tabs__table-row">
        <div class="tabs__table-col">{{ "ServiceElement.IPv6Prefix" | translate }}</div>
        <div class="tabs__table-col">{{ ipv6Prefix() }}</div>
      </div>
    }
    @if (ipv6AddressFirewall() !== null) {
      <div class="tabs__table-row">
        <div class="tabs__table-col">{{ "ServiceElement.IPv6AddressFirewall" | translate }}</div>
        <div class="tabs__table-col">{{ ipv6AddressFirewall() }}</div>
      </div>
    }
    @if (ipv6Mtu() !== null) {
      <div class="tabs__table-row">
        <div class="tabs__table-col">{{ "ServiceElement.IPv6MTU" | translate }}</div>
        <div class="tabs__table-col">{{ ipv6Mtu() }}</div>
      </div>
    }
    @if (ipv6MaxPrefix() !== null) {
      <div class="tabs__table-row">
        <div class="tabs__table-col">{{ "ServiceElement.IPv6MaxPrefix" | translate }}</div>
        <div class="tabs__table-col">{{ ipv6MaxPrefix() }}</div>
      </div>
    }
  </div>
</div>
